import React from 'react';
// import Swiper core and required modules
import { Pagination } from 'swiper/modules';
import './swiper.css';


import image1 from "./../../assets/fotos-lugares/1.webp";
import image2 from "./../../assets/fotos-lugares/2.webp";
import image3 from "./../../assets/fotos-lugares/3.webp";
import image4 from "./../../assets/fotos-lugares/4.webp";
import image5 from "./../../assets/fotos-lugares/5.webp";
import image6 from "./../../assets/fotos-lugares/6.webp";
import image7 from "./../../assets/fotos-lugares/7.webp";
import image8 from "./../../assets/fotos-lugares/8.webp";
import image9 from "./../../assets/fotos-lugares/9.webp";
import image10 from "./../../assets/fotos-lugares/10.webp";
import image11 from "./../../assets/fotos-lugares/11.webp";
import image12 from "./../../assets/fotos-lugares/12.webp";
import image13 from "./../../assets/fotos-lugares/13.webp";
import image14 from "./../../assets/fotos-lugares/14.webp";
import image15 from "./../../assets/fotos-lugares/15.webp";
import image16 from "./../../assets/fotos-lugares/16.webp";
import image17 from "./../../assets/fotos-lugares/17.webp";
import image18 from "./../../assets/fotos-lugares/18.webp";
import image19 from "./../../assets/fotos-lugares/19.webp";
import image20 from "./../../assets/fotos-lugares/20.webp";
import image21 from "./../../assets/fotos-lugares/21.webp";

import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css/effect-cube';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import { EffectCube } from 'swiper/modules';

export default function CustomSwiper() {

    const styleSwiperSlideImg = {
        'width': '100%',
        'height': '100%'
    }

    return (
        <>
            <Swiper
                style={
                    {
                        'width': '100%',
                        'height': '100%'
                    }
                }
                effect={'cube'}
                navigation={true}
                grabCursor={true}
                cubeEffect={{
                  shadow: false,
                  slideShadows: false,
                  shadowOffset: 20,
                  shadowScale: 0.94,
                }}
                modules={[EffectCube, Pagination]}
                className="swiperTuristico"
                preloadImages={false}
                loop={true}
                pagination= {
                    {
                        clickable: true,
                        dynamicBullets: true,}
                }
            >
            <SwiperSlide
            >
                <img
                src={image1}
                
                style={styleSwiperSlideImg}
                />
                <div className="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                <div className='captionInf'>
                    <p className='text-md '>
                        Peña del Cuervo: Un mirador espectacular en el Parque Nacional El Chico que ofrece una vista panorámica sobre las montañas y el mar de pinos; el lugar perfecto para fotos memorables.
                    </p>
                </div>
            </SwiperSlide>
            <SwiperSlide
                
            >
                <img
                src={image2}
                
                style={styleSwiperSlideImg}
                />
                <div className="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                <div className='captionInf'>
                    <p className='text-md '>
                        Presa El Cedral: Un hermoso parque recreativo rodeado de densos bosques de pino y encino. Es el lugar ideal para desconectarse de todo, ya sea paseando en lancha por su presa o simplemente disfrutando de la paz de la naturaleza.
                    </p>
                </div>
            </SwiperSlide>
            <SwiperSlide
                
            >
                <img
                src={image3}
                
                style={styleSwiperSlideImg}
                />
                <div className="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                <div className='captionInf'>
                    <p className='text-md '>
                        Mineral del Chico: El pintoresco corazón de este pueblo mágico, famoso por su arquitectura de techos rojos, calles empedradas y su antigua parroquia, todo enmarcado por las imponentes montañas del bosque.
                    </p>
                </div>
            </SwiperSlide>
            <SwiperSlide
                
            >
                <img
                src={image4}
                loading="lazy"
                style={styleSwiperSlideImg}
                />
                <div className="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                <div className='captionInf'>
                    <p className='text-md '>
                        Río El Milagro: Senderismo junto al río que combina naturaleza e historia, ideal para caminar entre antiguas minas y formaciones rocosas.
                    </p>
                </div>
            </SwiperSlide>
            <SwiperSlide
                
            >
                <img
                src={image5}
                loading="lazy"
                style={styleSwiperSlideImg}
                />
                <div className="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                <div className='captionInf'>
                    <p className='text-md '>
                        Vía Ferrata: Escalada a doscientos metros de altura en la montaña "La Tanda", perfecta para nuestros invitados que buscan adrenalina y fotos espectaculares.
                    </p>
                </div>
            </SwiperSlide>
            <SwiperSlide
                
            >
                <img
                src={image6}
                loading="lazy"
                style={styleSwiperSlideImg}
                />
                <div className="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                <div className='captionInf'>
                    <p className='text-md '>
                        Roca Bosque: Recorridos nocturnos por puentes colgantes iluminados. Es una actividad mágica para hacer en grupo.
                    </p>
                </div>
            </SwiperSlide>
            <SwiperSlide
                
            >
                <img
                src={image7}
                loading="lazy"
                style={styleSwiperSlideImg}
                />
                <div className="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                <div className='captionInf'>
                    <p className='text-md '>
                        Real del Monte: Un pintoresco pueblo de herencia minera inglesa, famoso por sus calles empedradas, su callejón de los artistas (ha sido escenario de telenovelas y películas como "Soy Frankelda") y por ser la cuna de los tradicionales pastes.
                    </p>
                </div>
            </SwiperSlide>
            <SwiperSlide
                
            >
                <img
                src={image8}
                loading="lazy"
                style={styleSwiperSlideImg}
                />
                <div className="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                <div className='captionInf'>
                    <p className='text-md '>
                        Panteón Inglés: Histórico cementerio ubicado en la cima de una montaña en Real del Monte, conocido por sus tumbas orientadas hacia Inglaterra y su atmósfera mística entre la neblina.
                    </p>
                </div>
            </SwiperSlide>
            <SwiperSlide
                
            >
                <img
                src={image9}
                loading="lazy"
                style={styleSwiperSlideImg}
                />
                <div className="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                <div className='captionInf'>
                    <p className='text-md '>
                        Prismas Basálticos: Impresionantes columnas naturales de roca en Huasca de Ocampo, otro pueblo cercano, famoso por ser cuna de duendes.
                    </p>
                </div>
            </SwiperSlide>
            <SwiperSlide
                
            >
                <img
                src={image10}
                loading="lazy"
                style={styleSwiperSlideImg}
                />
                <div className="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                <div className='captionInf'>
                    <p className='text-md '>
                        Piedra del Comal: Formación rocosa en Omitlán, un pueblo pintoresco más del corredor de la montaña hidalguense, destacado por sus murales y su callejón del juego de pelota.
                    </p>
                </div>
            </SwiperSlide>
            <SwiperSlide
                
            >
                <img
                src={image11}
                loading="lazy"
                style={styleSwiperSlideImg}
                />
                <div className="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                <div className='captionInf'>
                    <p className='text-md '>
                        Paste: Emblemático platillo adaptado de orígenes ingleses,  consistente en una fina masa quebrada horneada con diversos rellenos, basada en los "pasties" originales de Cornualles.
                    </p>
                </div>
            </SwiperSlide>
            <SwiperSlide
                
            >
                <img
                src={image12}
                loading="lazy"
                style={styleSwiperSlideImg}
                />
                <div className="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                <div className='captionInf'>
                    <p className='text-md '>
                        Zona Arqueológica de Teotihuacán: Un acercamiento a nuestra herencia indígena: Exploren las imponentes Pirámide del Sol y Pirámide de la Luna caminando por la Calzada de los Muertos.
                    </p>
                </div>
            </SwiperSlide>
            <SwiperSlide
                
            >
                <img
                src={image13}
                loading="lazy"
                style={styleSwiperSlideImg}
                />
                <div className="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                <div className='captionInf'>
                    <p className='text-md '>
                        Grutas de Tolantongo: Oasis de aguas termales turquesas, famoso por sus pozas escalonadas, túneles de vapor y su río templado dentro de un cañón.
                    </p>
                </div>
            </SwiperSlide>
            <SwiperSlide
                
            >
                <img
                src={image14}
                loading="lazy"
                style={styleSwiperSlideImg}
                />
                <div className="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                <div className='captionInf'>
                    <p className='text-md '>
                        Ixmiquilpan: Hogar de la Parroquia de San Miguel Arcángel, famosa por su arquitectura y frescos que fusionan la fe católica con el arte indígena.
                    </p>
                </div>
            </SwiperSlide>
            <SwiperSlide
                
            >
                <img
                src={image15}
                loading="lazy"
                style={styleSwiperSlideImg}
                />
                <div className="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                <div className='captionInf'>
                    <p className='text-md '>
                        Barbacoa de Hidalgo: Carne de borrego extra suave cocinada lentamente en horno de tierra con leña de encino y pencas de maguey. Es el sabor más emblemático del Valle del Mezquital y una experiencia obligada para el domingo por la mañana.
                    </p>
                </div>
            </SwiperSlide>
            <SwiperSlide
                
            >
                <img
                src={image16}
                loading="lazy"
                style={styleSwiperSlideImg}
                />
                <div className="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                <div className='captionInf'>
                    <p className='text-md '>
                        Bosque de las Truchas: Un parque natural en Huasca de Ocampo, el primer pueblo mágico de México, perfecto para un día de campo relajado, con lagos, criaderos de truchas y actividades como pesca o paseos a caballo.
                    </p>
                </div>
            </SwiperSlide>
            <SwiperSlide
                
            >
                <img
                src={image17}
                loading="lazy"
                style={styleSwiperSlideImg}
                />
                <div className="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                <div className='captionInf'>
                    <p className='text-md '>
                        Pulque: Conocido como la "bebida de los dioses", es un elixir prehispánico extraído del corazón del maguey. Pueden disfrutarlo en su versión natural o en los famosos "curados" de frutas, una experiencia esencial para brindar por la tradición de Hidalgo.
                    </p>
                </div>
            </SwiperSlide>
            <SwiperSlide
                
            >
                <img
                src={image18}
                loading="lazy"
                style={styleSwiperSlideImg}
                />
                <div className="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                <div className='captionInf'>
                    <p className='text-md '>
                        Pisal Ben Gurión: Una monumental obra de arte moderno en Pachuca. Se trata de un mosaico peatonal gigante con más de 7 millones de azulejos de colores que narran el "Homenaje a la Mujer del Mundo".
                    </p>
                </div>
            </SwiperSlide>
            <SwiperSlide
                
            >
                <img
                src={image19}
                loading="lazy"
                style={styleSwiperSlideImg}
                />
                <div className="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                <div className='captionInf'>
                    <p className='text-md '>
                        Salón de la Fama del Fútbol: Una estructura icónica en forma de balón gigante, única en su tipo, que rinde homenaje a las leyendas del fútbol mundial con exhibiciones interactivas y mucha historia deportiva.
                    </p>
                </div>
            </SwiperSlide>
            <SwiperSlide
                
            >
                <img
                src={image20}
                loading="lazy"
                style={styleSwiperSlideImg}
                />
                <div className="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                <div className='captionInf'>
                    <p className='text-md '>
                        Reloj Monumental: El icónico guardián de Pachuca, una joya arquitectónica cuya maquinaria fue fabricada por los mismos creadores del Big Ben.
                    </p>
                </div>
            </SwiperSlide>

            <SwiperSlide
                
            >
                <img
                src={image21}
                loading="lazy"
                style={styleSwiperSlideImg}
                />
                <div className="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                <div className='captionInf'>
                    <p className='text-md '>
                        Huasca de Ocampo: El primer Pueblo Mágico de México, es un rincón de calles empedradas que parece detenido en el tiempo. Es el lugar perfecto para caminar sin prisa y descubrir el origen de sus leyendas de duendes.
                    </p>
                </div>
            </SwiperSlide>
            </Swiper>
        </>
  );
};